import { useEffect, useState, useRef } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { useAuth } from '../context/AuthContext';
import { useVendorAuth } from '../context/VendorAuthContext';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCouponById, fetchCoupons } from '../state/slices/couponSlice';
import { fetchUserRedemptions } from '../state/slices/userSlice';

const ProductDetailsTwo = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { isAuthenticated, isSubscribed, user, token } = useAuth();
    const { isVendorAuthenticated } = useVendorAuth();
    const dispatch = useDispatch();

    const data = useSelector((state) => state.coupons.couponDetails[id]);
    const couponRating = useSelector(
        (state) => state.coupons.couponRatings[id] ?? { average: null, count: 0 }
    );
    const redemptions = useSelector((state) => state.user.redemptions);
    const subscriptionStartDate = useSelector((state) => state.user.subscriptionStartDate);
    const couponRedemptionCount = redemptions.filter((r) => {
        if (r.coupon_id !== parseInt(id)) return false;
        if (!subscriptionStartDate) return true;
        return new Date(r.redeemed_on) >= new Date(subscriptionStartDate);
    }).length;
    const hasRedeemedCoupon = redemptions.some((r) => r.coupon_id === parseInt(id));
    const hasReachedLimit = couponRedemptionCount >= 1;
    const allCoupons = useSelector((state) => Object.values(state.coupons.coupons));

    const coupon = data?.coupon;
    const imageSlots = [coupon?.image_url, coupon?.image_url_2, coupon?.image_url_3];

    const now = new Date();
    const startsAt  = coupon?.starts_at  ? new Date(coupon.starts_at)  : null;
    const expiresAt = coupon?.expires_at ? new Date(coupon.expires_at) : null;
    const notYetAvailable = startsAt  && now < startsAt;
    const isExpired       = expiresAt && now > expiresAt;
    const unavailable     = notYetAvailable || isExpired;

    const fmtDate = (d) => d ? d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }) : "";

    const [mainImage, setMainImage] = useState(null);
    const [ratings, setRatings] = useState([]);

    useEffect(() => {
        const first = [data?.coupon?.image_url, data?.coupon?.image_url_2, data?.coupon?.image_url_3].find(Boolean);
        if (first) setMainImage(first);
    }, [data?.coupon?.image_url, data?.coupon?.image_url_2, data?.coupon?.image_url_3]);
    const [repurchasing, setRepurchasing] = useState(false);

    const handleRepurchase = async () => {
        setRepurchasing(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/create-checkout-session`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    items: [{ title: "Fun Card Year Subscription", price: 30 }],
                    user_id: user?.id,
                    return_path: `/coupon/${id}`,
                }),
            });
            const data = await res.json();
            if (data.checkout_url) {
                window.location.href = data.checkout_url;
            }
        } catch (err) {
            console.error("Repurchase error:", err);
            setRepurchasing(false);
        }
    };

    useEffect(() => {
        dispatch(fetchCouponById(id));
    }, [id, dispatch]);

    useEffect(() => {
        if (!isAuthenticated || !user?.id) return;
        dispatch(fetchUserRedemptions({ userId: user.id, token }));
    }, [isAuthenticated, user, dispatch]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/ratings/coupon/${id}`)
            .then((res) => res.json())
            .then((d) => setRatings(d.ratings || []))
            .catch(() => {});
    }, [id]);

    useEffect(() => {
        dispatch(fetchCoupons());
    }, [dispatch]);

    const ratingCounts = ratings.reduce((acc, r) => {
        acc[r.rating] = (acc[r.rating] || 0) + 1;
        return acc;
    }, {});

    const currentCategory = data?.coupon?.discount_category;
    const relatedCoupons = allCoupons.filter(
        (c) => c.discount_category === currentCategory && c.id !== parseInt(id)
    );

    const relatedSliderRef = useRef(null);

    const relatedSettings = {
        dots: false,
        arrows: false,
        infinite: relatedCoupons.length > 4,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        variableWidth: true,
    };

    return (

        <section className="product-details py-80">
            {data ? <>
                    <div className="container container-lg">
                        <div className="row gy-4 justify-content-center">
                            <div className="col-xl-10">
                                <div className="row gy-4 align-items-start">
                                    <div className="col-xl-5">
                                        <div className="product-details__left">
                                            <div style={{ width: '75%' }}>
                                            <div className="border border-gray-100 rounded-16 overflow-hidden" style={{ aspectRatio: '1 / 1' }}>
                                                {mainImage ? (
                                                    <img
                                                        src={mainImage}
                                                        alt="Main Product"
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                                                    />
                                                ) : (
                                                    <div style={{ width: '100%', height: '100%', background: '#f3f4f6', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className="ph ph-image" style={{ fontSize: 64, color: '#d1d5db' }} />
                                                        <span style={{ fontSize: 13, color: '#9ca3af', marginTop: 8 }}>No image provided</span>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="d-flex gap-8 mt-16 flex-wrap">
                                                {imageSlots.map((image, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => image && setMainImage(image)}
                                                        className="border rounded-12 overflow-hidden flex-center"
                                                        style={{
                                                            width: 80,
                                                            height: 80,
                                                            cursor: image ? 'pointer' : 'default',
                                                            borderColor: image && mainImage === image ? 'var(--main-600, #333B94)' : '#e5e7eb',
                                                            borderWidth: image && mainImage === image ? 2 : 1,
                                                            borderStyle: 'solid',
                                                            flexShrink: 0,
                                                            background: '#f9fafb',
                                                        }}
                                                    >
                                                        {image ? (
                                                            <img
                                                                src={image}
                                                                alt={`Image ${index + 1}`}
                                                                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                                                            />
                                                        ) : (
                                                            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                <i className="ph ph-image" style={{ fontSize: 28, color: '#d1d5db' }} />
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-7">
                                        <div className="product-details__content">
                                            {/* <div className="flex-center mb-24 flex-wrap gap-16 bg-color-one rounded-8 py-16 px-24 position-relative z-1">
                                                <img
                                                    src="assets/images/bg/details-offer-bg.png"
                                                    alt=""
                                                    className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 z-n1"
                                                />
                                                <div className="flex-align gap-16">
                                                    <span className="text-white text-sm">Special Offer:</span>
                                                </div>
                                                <div className="countdown" id="countdown11">
                                                    <ul className="countdown-list flex-align flex-wrap">
                                                        <li className="countdown-list__item text-heading flex-align gap-4 text-xs fw-medium w-28 h-28 rounded-4 border border-main-600 p-0 flex-center">
                                                            {timeLeft.days}<span className="days" />
                                                        </li>
                                                        <li className="countdown-list__item text-heading flex-align gap-4 text-xs fw-medium w-28 h-28 rounded-4 border border-main-600 p-0 flex-center">
                                                            {timeLeft.hours}<span className="hours" />
                                                        </li>
                                                        <li className="countdown-list__item text-heading flex-align gap-4 text-xs fw-medium w-28 h-28 rounded-4 border border-main-600 p-0 flex-center">
                                                            {timeLeft.minutes}<span className="minutes" />
                                                        </li>
                                                        <li className="countdown-list__item text-heading flex-align gap-4 text-xs fw-medium w-28 h-28 rounded-4 border border-main-600 p-0 flex-center">
                                                            {timeLeft.seconds}<span className="seconds" />
                                                        </li>
                                                    </ul>
                                                </div>
                                                <span className="text-white text-xs">
                                                    Remains untill the end of the offer
                                                </span>
                                            </div> */}
                                            <h5 className="mb-12">
                                                {data?.coupon?.title}
                                            </h5>
                                            <div className="flex-align flex-wrap gap-12">
                                                <div className="flex-align gap-12 flex-wrap">
                                                    <div className="flex-align gap-4">
                                                        {[1,2,3,4,5].map(star => (
                                                            <span key={star} className={`text-15 fw-medium d-flex ${star <= Math.round(couponRating.average || 0) ? 'text-warning-600' : 'text-gray-300'}`}>
                                                                <i className="ph-fill ph-star" />
                                                            </span>
                                                        ))}
                                                    </div>
                                                    <span className="text-sm fw-medium text-neutral-600">
                                                        {couponRating.average != null
                                                            ? `${couponRating.average} Star Rating`
                                                            : "No Ratings Yet"}
                                                    </span>
                                                    <span className="text-sm fw-medium text-gray-500">
                                                        ({couponRating.count ?? 0})
                                                    </span>
                                                </div>
                                                <span className="text-sm fw-medium text-gray-500">|</span>
                                                <Link
                                                    to={`/vendor/${data?.coupon?.vendor_id}`}
                                                    className="text-gray-900 hover-text-main-800"
                                                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                                                >
                                                    {data?.business?.business_name}
                                                </Link>
                                                {data?.vendor?.website && (
                                                    <>
                                                        <span className="text-sm fw-medium text-gray-500">|</span>
                                                        <span className="text-sm fw-medium text-gray-700">
                                                            Website:{" "}
                                                            <a
                                                                href={data.vendor.website.startsWith("http") ? data.vendor.website : `https://${data.vendor.website}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ color: "#2575fc", textDecoration: "underline", cursor: "pointer" }}
                                                            >
                                                                {data.vendor.website}
                                                            </a>
                                                        </span>
                                                    </>
                                                )}
                                                {(data?.business?.facebook_url || data?.business?.twitter_url || data?.business?.yelp_url) && (
                                                    <span className="text-sm fw-medium text-gray-500">|</span>
                                                )}
                                                {data?.business?.facebook_url && (
                                                    <a
                                                        href={data.business.facebook_url.startsWith("http") ? data.business.facebook_url : `https://${data.business.facebook_url}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        title="Facebook"
                                                        style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 24, height: 24, borderRadius: '4px', background: '#1877f2', color: '#fff', fontSize: 13, flexShrink: 0, textDecoration: 'none' }}
                                                    >
                                                        <i className="ph-fill ph-facebook-logo" />
                                                    </a>
                                                )}
                                                {data?.business?.twitter_url && (
                                                    <a
                                                        href={data.business.twitter_url.startsWith("http") ? data.business.twitter_url : `https://${data.business.twitter_url}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        title="X (Twitter)"
                                                        style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 24, height: 24, borderRadius: '4px', background: '#000', color: '#fff', fontSize: 13, flexShrink: 0, textDecoration: 'none' }}
                                                    >
                                                        <i className="ph-fill ph-x-logo" />
                                                    </a>
                                                )}
                                                {data?.business?.yelp_url && (
                                                    <a
                                                        href={data.business.yelp_url.startsWith("http") ? data.business.yelp_url : `https://${data.business.yelp_url}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        title="Yelp"
                                                        style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 24, height: 24, borderRadius: '4px', background: '#d32323', color: '#fff', fontSize: 12, fontWeight: 900, fontFamily: 'Georgia, serif', flexShrink: 0, textDecoration: 'none', lineHeight: 1 }}
                                                    >
                                                        Y
                                                    </a>
                                                )}
                                            </div>
                                            <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />
                                            <p className="text-gray-700">
                                                {data?.coupon?.description}
                                            </p>
                                            <div className="my-32 flex-align gap-16 flex-wrap">
                                                <div className="flex-align gap-8">
                                                    <div className="flex-align gap-8 text-main-two-600">
                                                        <i className="ph-fill ph-seal-percent text-xl" />
                                                        {data?.coupon?.saving_percentage}% Off
                                                    </div>
                                                    <span style={{ width: '1px', height: '18px', backgroundColor: '#d1d5db', display: 'inline-block' }} />
                                                    <h6 className="mb-0">${data?.coupon?.dollar_savings_amount}</h6>
                                                    <span className="text-gray-500 fw-medium">In Savings</span>
                                                </div>
                                            </div>
                                            <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />
                                            {/* <div className="mt-32">
                                                <h6 className="mb-16">Quick Overview</h6>
                                                <div className="flex-between align-items-start flex-wrap gap-16">
                                                    <div>
                                                        <span className="text-gray-900 d-block mb-12">
                                                            Color:
                                                            <span className="fw-medium">Mineral Silver</span>
                                                        </span>
                                                        <div className="color-list flex-align gap-8">
                                                            <button
                                                                type="button"
                                                                className="color-list__button w-20 h-20 border border-2 border-gray-50 rounded-circle bg-info-600"
                                                            />
                                                            <button
                                                                type="button"
                                                                className="color-list__button w-20 h-20 border border-2 border-gray-50 rounded-circle bg-warning-600"
                                                            />
                                                            <button
                                                                type="button"
                                                                className="color-list__button w-20 h-20 border border-2 border-gray-50 rounded-circle bg-tertiary-600"
                                                            />
                                                            <button
                                                                type="button"
                                                                className="color-list__button w-20 h-20 border border-2 border-gray-50 rounded-circle bg-main-600"
                                                            />
                                                            <button
                                                                type="button"
                                                                className="color-list__button w-20 h-20 border border-2 border-gray-50 rounded-circle bg-gray-100"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <span className="text-gray-900 d-block mb-12">
                                                            Pattern Name:
                                                            <span className="fw-medium">with offer</span>
                                                        </span>
                                                        <div className="flex-align gap-8 flex-wrap">
                                                            <Link
                                                                to="#"
                                                                className="px-12 py-8 text-sm rounded-8 text-gray-900 border border-gray-200 hover-border-main-600 hover-text-main-800"
                                                            >
                                                                with offer{" "}
                                                            </Link>
                                                            <Link
                                                                to="#"
                                                                className="px-12 py-8 text-sm rounded-8 text-gray-900 border border-gray-200 hover-border-main-600 hover-text-main-800"
                                                            >
                                                                12th Gen Laptop
                                                            </Link>
                                                            <Link
                                                                to="#"
                                                                className="px-12 py-8 text-sm rounded-8 text-gray-900 border border-gray-200 hover-border-main-600 hover-text-main-800"
                                                            >
                                                                without offer
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}
                                            {/* <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" /> */}
                                            {!isVendorAuthenticated && (
                                                isAuthenticated && isSubscribed ? (
                                                    hasReachedLimit ? (
                                                        <div className="d-flex flex-column gap-12">
                                                            <button
                                                                disabled
                                                                className="btn btn-black flex-center gap-8 rounded-8 py-16 w-100"
                                                                style={{ opacity: 0.5, cursor: "not-allowed" }}
                                                            >
                                                                <i className="ph ph-x-circle text-lg" />
                                                                Redemption Limit Reached
                                                            </button>
                                                            <p className="text-gray-500 text-sm mb-0 text-center">
                                                                You've already redeemed this coupon for your current subscription period.
                                                            </p>
                                                            <button
                                                                onClick={handleRepurchase}
                                                                disabled={repurchasing}
                                                                className="btn bg-main-600 text-white hover-bg-main-700 flex-center gap-8 rounded-8 py-16 w-100"
                                                                style={{ opacity: repurchasing ? 0.6 : 1 }}
                                                            >
                                                                <i className="ph ph-arrow-clockwise text-lg" />
                                                                {repurchasing ? "Redirecting to Checkout..." : "Repurchase Fun Card to Reset Coupons"}
                                                            </button>
                                                        </div>
                                                    ) : unavailable ? (
                                                        <div className="d-flex flex-column align-items-center gap-8">
                                                            <button
                                                                disabled
                                                                className="btn btn-black flex-center gap-8 rounded-8 py-16 w-100"
                                                                style={{ opacity: 0.45, cursor: "not-allowed" }}
                                                            >
                                                                <i className="ph ph-clock text-lg" />
                                                                {isExpired
                                                                    ? "Coupon Expired"
                                                                    : `Not Available Until ${fmtDate(startsAt)}`}
                                                            </button>
                                                            {notYetAvailable && (
                                                                <p className="text-gray-500 text-sm mb-0 text-center">
                                                                    This coupon becomes redeemable on <strong>{fmtDate(startsAt)}</strong>.
                                                                </p>
                                                            )}
                                                            {isExpired && (
                                                                <p className="text-gray-500 text-sm mb-0 text-center">
                                                                    This coupon expired on {fmtDate(expiresAt)}.
                                                                </p>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <Link
                                                            to={`/coupon/${id}/redemption-process`}
                                                            className="btn btn-black flex-center gap-8 rounded-8 py-16"
                                                        >
                                                            <i className="ph ph-ticket text-lg" />
                                                            Redeem Coupon
                                                        </Link>
                                                    )
                                                ) : (
                                                    <Link
                                                        to={isAuthenticated ? "/cart" : "/account-login"}
                                                        state={{ from: `/coupon/${id}` }}
                                                        className="btn btn-black flex-center gap-8 rounded-8 py-16"
                                                    >
                                                        <i className="ph ph-whatsapp-logo text-lg" />
                                                        Buy Fun Card To Receive Coupon
                                                    </Link>
                                                )
                                            )}
                                            {!isVendorAuthenticated && isAuthenticated && hasRedeemedCoupon && (
                                                <Link
                                                    to={`/coupon/${id}/review`}
                                                    className="btn btn-outline-main flex-center gap-8 rounded-8 py-16 mt-16"
                                                >
                                                    <i className="ph ph-pencil text-lg" />
                                                    Write a Review
                                                </Link>
                                            )}
                                            <div className="mt-32">
                                                <span className="fw-medium text-gray-900">
                                                    100% Safe Checkout Guaranteed
                                                 </span>
                                                {/* <div className="mt-10">
                                                    <img src="assets/images/thumbs/gateway-img.png" alt="" />
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-xl-3">
                                <div className="product-details__sidebar py-40 px-32 border border-gray-100 rounded-16">
                                    <div className="mb-32">
                                        <label
                                            htmlFor="delivery"
                                            className="h6 activePage mb-8 text-heading fw-semibold d-block"
                                        >
                                            Delivery
                                        </label>
                                        <div className="flex-align border border-gray-100 rounded-4 px-16">
                                            <span className="text-xl d-flex text-main-600">
                                                <i className="ph ph-map-pin" />
                                            </span>
                                            <select defaultValue={1}
                                                className="common-input border-0 px-8 rounded-4"
                                                id="delivery"
                                            >
                                                <option value={1}>Maymansign</option>
                                                <option value={1}>Khulna</option>
                                                <option value={1}>Rajshahi</option>
                                                <option value={1}>Rangpur</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="mb-32">
                                        <label
                                            htmlFor="stock"
                                            className="text-lg mb-8 text-heading fw-semibold d-block"
                                        >
                                            Total Stock: 21
                                        </label>
                                        <span className="text-xl d-flex">
                                            <i className="ph ph-location" />
                                        </span>
                                        <div className="d-flex rounded-4 overflow-hidden">
                                            <button onClick={decrementQuantity}
                                                type="button"
                                                className="quantity__minus flex-shrink-0 h-48 w-48 text-white bg-main-600 flex-center hover-bg-main-700 hover-text-white"
                                            >
                                                <i className="ph ph-minus" />
                                            </button>
                                            <input
                                                type="number"
                                                className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-16"
                                                id="stock"
                                                value={
                                                    quantity
                                                } readOnly

                                            />
                                            <button onClick={incrementQuantity}
                                                type="button"
                                                className="quantity__plus flex-shrink-0 h-48 w-48 text-white bg-main-600 flex-center hover-bg-main-700 hover-text-white"
                                            >
                                                <i className="ph ph-plus" />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mb-32">
                                        <div className="flex-between flex-wrap gap-8 border-bottom border-gray-100 pb-16 mb-16">
                                            <span className="text-gray-500">Price</span>
                                            <h6 className="text-lg mb-0">$150.00</h6>
                                        </div>
                                        <div className="flex-between flex-wrap gap-8">
                                            <span className="text-gray-500">Shipping</span>
                                            <h6 className="text-lg mb-0">From $10.00</h6>
                                        </div>
                                    </div>
                                    <Link
                                        to="#"
                                        className="btn btn-main flex-center gap-8 rounded-8 py-16 fw-normal mt-48"
                                    >
                                        <i className="ph ph-shopping-cart-simple text-lg" />
                                        Add To Cart
                                    </Link>
                                    <Link
                                        to="#"
                                        className="btn btn-outline-main rounded-8 py-16 fw-normal mt-16 w-100"
                                    >
                                        Buy Now
                                    </Link>
                                    <div className="mt-32">
                                        <div className="px-16 py-8 bg-main-50 rounded-8 flex-between gap-24 mb-14">
                                            <span className="w-32 h-32 bg-white text-main-600 rounded-circle flex-center text-xl flex-shrink-0">
                                                <i className="ph-fill ph-truck" />
                                            </span>
                                            <span className="text-sm text-neutral-600">
                                                Ship from <span className="fw-semibold">MarketPro</span>{" "}
                                            </span>
                                        </div>
                                        <div className="px-16 py-8 bg-main-50 rounded-8 flex-between gap-24 mb-0">
                                            <span className="w-32 h-32 bg-white text-main-600 rounded-circle flex-center text-xl flex-shrink-0">
                                                <i className="ph-fill ph-storefront" />
                                            </span>
                                            <span className="text-sm text-neutral-600">
                                                Sold by:{" "}
                                                <span className="fw-semibold">MR Distribution LLC</span>{" "}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="mt-32">
                                        <div className="px-32 py-16 rounded-8 border border-gray-100 flex-between gap-8">
                                            <Link to="#" className="d-flex text-main-600 text-28">
                                                <i className="ph-fill ph-chats-teardrop" />
                                            </Link>
                                            <span className="h-26 border border-gray-100" />
                                            <div className="dropdown on-hover-item">
                                                <button className="d-flex text-main-600 text-28" type="button">
                                                    <i className="ph-fill ph-share-network" />
                                                </button>
                                                <div className="on-hover-dropdown common-dropdown border-0 inset-inline-start-auto inset-inline-end-0">
                                                    <ul className="flex-align gap-16">
                                                        <li>
                                                            <Link
                                                                to="/https://www.facebook.com"
                                                                className="w-44 h-44 flex-center bg-main-600 text-white text-xl rounded-circle hover-bg-main-700 hover-text-white"
                                                            >
                                                                <i className="ph-fill ph-facebook-logo" />
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link
                                                                to="/https://www.twitter.com"
                                                                className="w-44 h-44 flex-center bg-main-600 text-white text-xl rounded-circle hover-bg-main-700 hover-text-white"
                                                            >
                                                                <i className="ph-fill ph-twitter-logo" />
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link
                                                                to="/https://www.linkedin.com"
                                                                className="w-44 h-44 flex-center bg-main-600 text-white text-xl rounded-circle hover-bg-main-700 hover-text-white"
                                                            >
                                                                <i className="ph-fill ph-instagram-logo" />
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link
                                                                to="/https://www.pinterest.com"
                                                                className="w-44 h-44 flex-center bg-main-600 text-white text-xl rounded-circle hover-bg-main-700 hover-text-white"
                                                            >
                                                                <i className="ph-fill ph-linkedin-logo" />
                                                            </Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                        <div className="pt-80">
                            <div className="product-dContent border rounded-24">
                                <div className="product-dContent__header border-bottom border-gray-100 flex-between flex-wrap gap-16">
                                    <ul
                                        className="nav common-tab nav-pills mb-3"
                                        id="pills-tab"
                                        role="tablist"
                                    >
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link active"
                                                id="pills-description-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#pills-description"
                                                type="button"
                                                role="tab"
                                                aria-controls="pills-description"
                                                aria-selected="true"
                                            >
                                                Description
                                            </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button
                                                className="nav-link"
                                                id="pills-reviews-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#pills-reviews"
                                                type="button"
                                                role="tab"
                                                aria-controls="pills-reviews"
                                                aria-selected="false"
                                            >
                                                Reviews
                                            </button>
                                        </li>
                                    </ul>
                                    <Link
                                        to="#"
                                        className="btn bg-color-one rounded-16 flex-align gap-8 text-main-600 hover-bg-main-600 hover-text-white"
                                    >
                                        <img src="assets/images/icon/satisfaction-icon.png" alt="" />
                                        100% Satisfaction Guaranteed
                                    </Link>
                                </div>
                                <div className="product-dContent__box">
                                    <div className="tab-content" id="pills-tabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="pills-description"
                                            role="tabpanel"
                                            aria-labelledby="pills-description-tab"
                                            tabIndex={0}
                                        >
                                            <div className="mb-40">
                                                <h6 className="mb-24">Product Description</h6>
                                                <p>
                                                    {data?.coupon?.description}
                                                </p>
                                                {/* <ul className="list-inside mt-32 ms-16">
                                                    <li className="text-gray-400 mb-4">
                                                        8.0 oz. bag of LAY'S Classic Potato Chips
                                                    </li>
                                                    <li className="text-gray-400 mb-4">
                                                        Tasty LAY's potato chips are a great snack
                                                    </li>
                                                    <li className="text-gray-400 mb-4">
                                                        Includes three ingredients: potatoes, oil, and salt
                                                    </li>
                                                    <li className="text-gray-400 mb-4">Gluten free product</li>
                                                </ul>
                                                <ul className="mt-32">
                                                    <li className="text-gray-400 mb-4">Made in USA</li>
                                                    <li className="text-gray-400 mb-4">Ready To Eat.</li>
                                                </ul> */}
                                            </div>
                                            <div className="mb-40">
                                                <h6 className="mb-24">Coupon Specifications</h6>
                                                <ul className="mt-32">
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-heading fw-medium">
                                                            Coupon Type:
                                                            <div className="text-gray-500">{data?.coupon?.coupon_type} based</div>
                                                        </span>
                                                    </li>
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-heading fw-medium">
                                                            Coupon Name:
                                                            <div className="text-gray-500">
                                                                  {data?.coupon?.title}
                                                            </div>
                                                        </span>
                                                    </li>
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-heading fw-medium">
                                                            Discount Category:
                                                            <div className="text-gray-500">{data?.coupon?.discount_category}</div>
                                                        </span>
                                                    </li>
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-heading fw-medium">
                                                            Savings Percentage:
                                                            <div className="text-gray-500">{Math.trunc(data?.coupon?.saving_percentage)}%</div>
                                                        </span>
                                                    </li>
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-heading fw-medium">
                                                            Coupon Dollar Savings Amount:
                                                            <div className="text-gray-500">${data?.coupon?.dollar_savings_amount}</div>
                                                        </span>
                                                    </li>
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-heading fw-medium">
                                                            Maximum Allowed Redemptions Per Subscription:
                                                            <div className="text-gray-500">
                                                                {data?.coupon?.max_redemptions_per_user}
                                                            </div>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                            {/* <div className="mb-40">
                                                <h6 className="mb-24">Nutrition Facts</h6>
                                                <ul className="mt-32">
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-heading fw-medium">
                                                            {" "}
                                                            Total Fat 10g 13%
                                                        </span>
                                                    </li>
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-heading fw-medium">
                                                            {" "}
                                                            Saturated Fat 1.5g 7%
                                                        </span>
                                                    </li>
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-heading fw-medium">
                                                            {" "}
                                                            Cholesterol 0mg 0%
                                                        </span>
                                                    </li>
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-heading fw-medium">
                                                            {" "}
                                                            Sodium 170mg 7%
                                                        </span>
                                                    </li>
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-heading fw-medium">
                                                            {" "}
                                                            Potassium 350mg 6%
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div> */}
                                            <div className="mb-0">
                                                <h6 className="mb-24">{data?.business?.business_name} Information</h6>
                                                <ul className="mt-32">
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-gray-500">
                                                            {data?.business?.address}
                                                        </span>
                                                    </li>
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-gray-500">
                                                            {data?.business?.city}
                                                        </span>
                                                    </li>
                                                    <li className="text-gray-400 mb-14 flex-align gap-14">
                                                        <span className="w-20 h-20 bg-main-50 text-main-600 text-xs flex-center rounded-circle">
                                                            <i className="ph ph-check" />
                                                        </span>
                                                        <span className="text-gray-500">
                                                            {data?.business?.zipcode}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div
                                            className="tab-pane fade"
                                            id="pills-reviews"
                                            role="tabpanel"
                                            aria-labelledby="pills-reviews-tab"
                                            tabIndex={0}
                                        >
                                            <div className="row g-4">
                                                <div className="col-lg-6">
                                                    <h6 className="mb-24">Customer Reviews</h6>
                                                    {ratings.length === 0 ? (
                                                        <p className="text-gray-500">No reviews yet.</p>
                                                    ) : (
                                                        ratings.map((r, idx) => (
                                                            <div
                                                                key={r.id}
                                                                className={`d-flex align-items-start gap-24${idx < ratings.length - 1 ? " pb-44 border-bottom border-gray-100 mb-44" : ""}`}
                                                            >
                                                                <div
                                                                    className="w-52 h-52 rounded-circle flex-shrink-0 bg-main-50 flex-center"
                                                                    style={{ minWidth: 52 }}
                                                                >
                                                                    <span className="text-main-600 fw-bold text-lg">
                                                                        {r.user_name?.[0] ?? "?"}
                                                                    </span>
                                                                </div>
                                                                <div className="flex-grow-1">
                                                                    <div className="flex-between align-items-start gap-8">
                                                                        <div>
                                                                            <h6 className="mb-12 text-md">{r.user_name}</h6>
                                                                            <div className="flex-align gap-8">
                                                                                {[1, 2, 3, 4, 5].map((star) => (
                                                                                    <span
                                                                                        key={star}
                                                                                        className={`text-15 fw-medium d-flex ${star <= r.rating ? "text-warning-600" : "text-gray-300"}`}
                                                                                    >
                                                                                        <i className="ph-fill ph-star" />
                                                                                    </span>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                        <span className="text-gray-800 text-xs">
                                                                            {new Date(r.created_at).toLocaleDateString("en-US", {
                                                                                month: "short",
                                                                                day: "numeric",
                                                                                year: "numeric",
                                                                            })}
                                                                        </span>
                                                                    </div>
                                                                    {r.review && (
                                                                        <p className="text-gray-700 mt-16">{r.review}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))
                                                    )}
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="ms-xxl-5">
                                                        <h6 className="mb-24">Customers Feedback</h6>
                                                        <div className="d-flex flex-wrap gap-44">
                                                            <div className="border border-gray-100 rounded-8 px-40 py-52 flex-center flex-column flex-shrink-0 text-center">
                                                                <h2 className="mb-6 text-main-600">{couponRating.average ?? "—"}</h2>
                                                                <div className="flex-center gap-4">
                                                                    {[1,2,3,4,5].map(star => (
                                                                        <span key={star} className={`text-15 fw-medium d-flex ${star <= Math.round(couponRating.average || 0) ? 'text-warning-600' : 'text-gray-300'}`}>
                                                                            <i className="ph-fill ph-star" />
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                                <span className="mt-16 text-gray-500">
                                                                    {couponRating.count ?? 0} {couponRating.count === 1 ? "Review" : "Reviews"}
                                                                </span>
                                                            </div>
                                                            <div className="border border-gray-100 rounded-8 px-24 py-40 flex-grow-1">
                                                                {[5, 4, 3, 2, 1].map((stars, idx) => {
                                                                    const count = ratingCounts[stars] || 0;
                                                                    const pct = ratings.length > 0 ? Math.round((count / ratings.length) * 100) : 0;
                                                                    return (
                                                                        <div key={stars} className={`flex-align gap-8${idx < 4 ? " mb-20" : " mb-0"}`}>
                                                                            <span className="text-gray-900 flex-shrink-0">{stars}</span>
                                                                            <div
                                                                                className="progress w-100 bg-gray-100 rounded-pill h-8"
                                                                                role="progressbar"
                                                                                aria-label={`${stars} stars`}
                                                                                aria-valuenow={pct}
                                                                                aria-valuemin={0}
                                                                                aria-valuemax={100}
                                                                            >
                                                                                <div
                                                                                    className="progress-bar bg-main-600 rounded-pill"
                                                                                    style={{ width: `${pct}%` }}
                                                                                />
                                                                            </div>
                                                                            <div className="flex-align gap-4">
                                                                                {[1, 2, 3, 4, 5].map((s) => (
                                                                                    <span
                                                                                        key={s}
                                                                                        className={`text-xs fw-medium d-flex ${s <= stars ? "text-warning-600" : "text-gray-400"}`}
                                                                                    >
                                                                                        <i className="ph-fill ph-star" />
                                                                                    </span>
                                                                                ))}
                                                                            </div>
                                                                            <span className="text-gray-900 flex-shrink-0">({count})</span>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {relatedCoupons.length > 0 && (
                        <div className="container container-lg mt-64 pb-80">
                            <div className="border border-gray-100 p-24 rounded-16">
                                <div className="section-heading mb-24">
                                    <div className="flex-between flex-wrap gap-8">
                                        <h5 className="mb-0">You May Also Like</h5>
                                    </div>
                                </div>
                                <div className="top-selling-product-wrapper position-relative" style={{ paddingRight: '56px' }}>
                                    <div className="top-selling-product-slider">
                                        <Slider ref={relatedSliderRef} {...relatedSettings}>
                                            {relatedCoupons.map((coupon) => (
                                                <div key={coupon.id} style={{ width: '260px', paddingRight: '16px', boxSizing: 'border-box' }}>
                                                    <div className="product-card h-100 p-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                                                        <div
                                                            onClick={() => navigate(`/coupon/${coupon.id}`)}
                                                            className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                                                            style={{ overflow: 'hidden', cursor: 'pointer' }}
                                                        >
                                                            <span className="product-card__badge bg-main-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                                                                Hot
                                                            </span>
                                                            {coupon.image_url ? (
                                                                <img
                                                                    src={coupon.image_url}
                                                                    alt=""
                                                                    style={{ width: '100%', height: '100%', maxWidth: 'none', maxHeight: 'none', objectFit: 'cover', position: 'absolute', inset: 0 }}
                                                                />
                                                            ) : (
                                                                <img
                                                                    src="assets/images/thumbs/product-two-img7.png"
                                                                    alt=""
                                                                    className="w-auto max-w-unset"
                                                                />
                                                            )}
                                                        </div>
                                                        {coupon.business_name && (
                                                            <div className="flex-align gap-4" style={{ marginTop: "12px" }}>
                                                                <span className="text-tertiary-600 text-sm d-flex"><i className="ph-fill ph-storefront" /></span>
                                                                <span className="text-lg fw-semibold text-gray-500" style={{ fontFamily: "var(--heading-font)", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block', minWidth: 0 }}>{coupon.business_name}</span>
                                                            </div>
                                                        )}
                                                        <div className="product-card__content w-100 mt-16">
                                                            <div className="flex-align gap-6">
                                                                <div className="flex-align gap-4">
                                                                    {[1, 2, 3, 4, 5].map((star) => (
                                                                        <span key={star} className={`text-xs fw-medium d-flex ${star <= Math.round(coupon.average_rating || 0) ? 'text-warning-600' : 'text-gray-300'}`}>
                                                                            <i className="ph-fill ph-star" />
                                                                        </span>
                                                                    ))}
                                                                </div>
                                                                <span className="text-xs fw-medium text-gray-500">{coupon.average_rating ?? "—"}</span>
                                                                <span className="text-xs fw-medium text-gray-500">({coupon.rating_count ?? 0})</span>
                                                            </div>
                                                            <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                                                <div
                                                                    onClick={() => navigate(`/coupon/${coupon.id}`)}
                                                                    className="link d-block"
                                                                    style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer' }}
                                                                >
                                                                    {coupon.title}
                                                                </div>
                                                            </h6>
                                                            {coupon.description && (
                                                                <p className="text-sm text-gray-500 mb-8" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                    {coupon.description}
                                                                </p>
                                                            )}
                                                            <div className="product-card__price my-20 flex-align gap-4">
                                                                <span className="text-heading text-md fw-semibold">
                                                                    ${coupon.dollar_savings_amount}
                                                                </span>
                                                                <span className="text-gray-500 text-sm fw-medium">In Savings</span>
                                                                <span style={{ width: '1px', height: '14px', backgroundColor: '#d1d5db', display: 'inline-block', margin: '0 4px' }} />
                                                                <span className="text-main-800 text-sm fw-semibold">{coupon.saving_percentage}% Off</span>
                                                            </div>
                                                            {!isVendorAuthenticated && (
                                                                isAuthenticated && isSubscribed ? (
                                                                    <Link
                                                                        to={`/coupon/${coupon.id}`}
                                                                        className="product-card__cart w-100 btn bg-main-800 text-white hover-bg-main-700 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium w-100"
                                                                    >
                                                                        Redeem Coupon <i className="ph ph-shopping-cart" />
                                                                    </Link>
                                                                ) : (
                                                                    <Link
                                                                        to={isAuthenticated ? "/cart" : "/account-login"}
                                                                        state={{ from: `/coupon/${coupon.id}` }}
                                                                        className="product-card__cart w-100 btn bg-main-800 text-white hover-bg-main-700 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium w-100"
                                                                    >
                                                                        Buy Fun Card <i className="ph ph-shopping-cart" />
                                                                    </Link>
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={() => relatedSliderRef.current?.slickNext()}
                                        className="flex-center rounded-circle text-xl"
                                        style={{
                                            position: 'absolute',
                                            right: 0,
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            zIndex: 10,
                                            width: '40px',
                                            height: '40px',
                                            background: 'linear-gradient(135deg, #4da8e8 0%, #2575fc 100%)',
                                            border: 'none',
                                            boxShadow: '0 4px 12px rgba(37,117,252,0.32)',
                                            cursor: 'pointer',
                                            transition: 'opacity 0.15s, transform 0.15s, box-shadow 0.15s',
                                        }}
                                        onMouseEnter={e => { e.currentTarget.style.opacity = '0.88'; e.currentTarget.style.transform = 'translateY(-50%) scale(1.09)'; e.currentTarget.style.boxShadow = '0 6px 18px rgba(37,117,252,0.45)'; }}
                                        onMouseLeave={e => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.transform = 'translateY(-50%)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(37,117,252,0.32)'; }}
                                    >
                                        <i className="ph ph-caret-right" style={{ color: 'white' }} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </> : null}
        </section>

    )
}

export default ProductDetailsTwo